import { WarrantyLogModel } from '../../../model/types';
import styles from './styles.module.scss';
import { FC } from 'react';

export const IdCell: FC<{ data: WarrantyLogModel }> = ({ data }) => {
  return (
    <div className={styles.idCell}>
      <div className={styles.textBold}>{data.id}</div>
      <div>{data.branchName}</div>
    </div>
  );
};
